export default IconClockExclamation => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-clock-exclamation" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M20.986 12.502a9 9 0 1 0 -5.973 7.98" />
  <path d="M12 7v5l3 3" />
  <path d="M19 16v3" />
  <path d="M19 22v.01" />
</svg>`;